import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteProductProjectPlanDialogProps = {
  open: boolean;
  productProjectPlanId: GridRowId;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteProductProjectPlanDialog = ({
  open,
  productProjectPlanId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteProductProjectPlanDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    try {
      setLoading(true);

      const response = await apiService.deleteProductProjectPlan(Number(productProjectPlanId));

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="productProjectPlan.deleteProductProjectPlanCompleted"
            defaultMessage="Seçili ürün - proje planını silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={
        <FormattedMessage id="productProjectPlan.deleteProductProjectPlan" defaultMessage="Ürün - Proje Planı Sil" />
      }
      description={
        <FormattedMessage
          id="productProjectPlan.deleteProductProjectPlanRepeat"
          defaultMessage="Bu işlem onaylandıktan sonra ürün - proje planı veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteProductProjectPlanDialog;
